import React, { useState } from 'react';
import { PaystackPayment } from './PaystackPayment';
interface PaymentFormProps {
  onSuccess?: (reference: string) => void;
}
export const PaymentForm: React.FC<PaymentFormProps> = ({
  onSuccess
}) => {
  const [formData, setFormData] = useState({
    email: '',
    fullName: '',
    sex: '',
    phone: '',
    location: '',
    industry: '',
    occupation: '',
    commitment: '',
    mediaConsent: '',
    comments: ''
  });
  const [isFormComplete, setIsFormComplete] = useState(false);
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    // Check if required fields are complete
    setTimeout(() => {
      const requiredFields = ['email', 'fullName', 'sex', 'phone', 'location', 'industry', 'occupation', 'commitment', 'mediaConsent'];
      const isComplete = requiredFields.every(field => formData[field]);
      setIsFormComplete(isComplete && formData.email.includes('@'));
    }, 100);
  };
  return <div className="w-full max-w-lg mx-auto" data-id="element-968" data-mp="34a0yy366gpnx">
      <div className="mb-6" data-id="element-969" data-mp="34990mkl74dty">
        <h2 className="text-xl font-bold text-gray-800 mb-4" data-id="element-970" data-mp="2zbhb1x80x3sx">
          Join The Networking Salon Inner Circle
        </h2>
        <p className="text-gray-600 mb-4" data-id="element-971" data-mp="2ucw6xmpnhzz7">
          Complete the form below to join for ₦20,000 (Founder's Offer)
        </p>
      </div>
      <div className="space-y-4 mb-6" data-id="element-972" data-mp="3rzlk8spszz0d">
        <div data-id="element-973" data-mp="3n11sgboj3t03">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-974" data-mp="3n0ich0ifveop">
            Email <span className="text-gray-500" data-id="element-975" data-mp="3i9tjthv0wbnz">(required)</span>
          </label>
          <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your email address" required data-id="element-976" data-mp="3db8jlifrtrzj" />
        </div>
        <div data-id="element-977" data-mp="9u04v7gcb891">
          <label htmlFor="fullName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-978" data-mp="9u9xz3wolviy">
            Full Name <span className="text-gray-500" data-id="element-979" data-mp="243f2lynlmh51">(required)</span>
          </label>
          <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your full name" required data-id="element-980" data-mp="291ymltimtiur" />
        </div>
        <div data-id="element-981" data-mp="1zacgucp2cbze">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-982" data-mp="1za2q2mw720sn">
            Sex <span className="text-gray-500" data-id="element-983" data-mp="1lat75fglsskz">(required)</span>
          </label>
          <div className="space-y-2" data-id="element-984" data-mp="1pdzekqfgcpt1">
            {['Male', 'Female'].map(option => <div key={option} className="flex items-center" data-id="element-985" data-mp="1bdok7dexot34">
                <input type="radio" id={`sex-${option}`} name="sex" value={option} checked={formData.sex === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-986" data-mp="1bf9h39oq0o45" />
                <label htmlFor={`sex-${option}`} className="text-gray-700" data-id="element-987" data-mp="35s943nvfkklg">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-988" data-mp="z4igvl7wo57u">
          <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-989" data-mp="z48m7kbx19vt">
            Phone Number <span className="text-gray-500" data-id="element-990" data-mp="u5xh1mwkfnjx">(required)</span>
          </label>
          <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your phone number" required data-id="element-991" data-mp="18ubq4fkks88x" />
        </div>
        <div data-id="element-992" data-mp="1hsdm2gpgcapc">
          <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-993" data-mp="1hs3z71zpejnv">
            City of Residence <span className="text-gray-500" data-id="element-994" data-mp="1cx823nfm163w">(required)</span>
          </label>
          <select id="location" name="location" value={formData.location} onChange={handleChange} required className="w-full p-2 border border-gray-300 rounded-md" data-id="element-995" data-mp="1rrcxu85ikmgk">
            <option value="" data-id="element-996" data-mp="3tipt05hojfzf">Select your city</option>
            <option value="Houston Texas" data-id="element-997" data-mp="3tlc76nz2stqm">Houston Texas</option>
            <option value="Lagos" data-id="element-998" data-mp="3olps08zot3f6">Lagos</option>
            <option value="Abuja" data-id="element-999" data-mp="2fng78tljwxzg">Abuja</option>
            <option value="Benin City" data-id="element-1000" data-mp="2fmodzpfffccc">Benin City</option>
            <option value="Warri" data-id="element-1001" data-mp="2kmarlzz62ulo">Warri</option>
            <option value="Berlin" data-id="element-1002" data-mp="2kkzom2djpqvm">Berlin</option>
            <option value="Port Harcourt" data-id="element-1003" data-mp="2plx6edun8iwl">Port Harcourt</option>
            <option value="UK" data-id="element-1004" data-mp="2pjjbc4zyr6p1">UK</option>
            <option value="Other" data-id="element-1005" data-mp="2tnr0u4e8wqob">Other</option>
          </select>
        </div>
        <div data-id="element-1006" data-mp="1wwylxa31t4o4">
          <label htmlFor="industry" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1007" data-mp="1wxi3gposdr1m">
            Industry <span className="text-gray-500" data-id="element-1008" data-mp="21vjmxbq4jsdm">(required)</span>
          </label>
          <input type="text" id="industry" name="industry" value={formData.industry} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter your industry" required data-id="element-1009" data-mp="25xoem4x0iexm" />
        </div>
        <div data-id="element-1010" data-mp="1e70aql3yevg9">
          <label htmlFor="occupation" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1011" data-mp="1e5fkh7oo9yo7">
            What do you do? <span className="text-gray-500" data-id="element-1012" data-mp="1i6r8x9vt8dut">(required)</span>
          </label>
          <textarea id="occupation" name="occupation" value={formData.occupation} onChange={handleChange} rows={3} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Describe your occupation or role" required data-id="element-1013" data-mp="1aot25d50jgva" />
        </div>
        <div data-id="element-1014" data-mp="11pzdqa1u5wst">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1015" data-mp="11ppia6y0uxfq">
            Are you committed to actively participating in the ways described
            above? <span className="text-gray-500" data-id="element-1016" data-mp="rr9t49ik1y8v">(required)</span>
          </label>
          <div className="space-y-2" data-id="element-1017" data-mp="myqinlf5zj8a">
            {['Yes', 'No', 'I have questions'].map(option => <div key={option} className="flex items-center" data-id="element-1018" data-mp="hzdr4ndclnzd">
                <input type="radio" id={`commitment-${option}`} name="commitment" value={option} checked={formData.commitment === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-1019" data-mp="hxj7dcdtc1wv" />
                <label htmlFor={`commitment-${option}`} className="text-gray-700" data-id="element-1020" data-mp="40e7ju4ozza2">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-1021" data-mp="3qk8zumqobg30">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1022" data-mp="3vgpsnu8tiimf">
            Are you okay with your pictures and videos of you taken at our
            events (in-person or online) be used for promotional purposes?{' '}
            <span className="text-gray-500" data-id="element-1023" data-mp="3ljus75szi85i">(required)</span>
          </label>
          <div className="space-y-2" data-id="element-1024" data-mp="d2gjv93q3rua">
            {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-1025" data-mp="d5ch0v7qycho">
                <input type="radio" id={`mediaConsent-${option}`} name="mediaConsent" value={option} checked={formData.mediaConsent === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-1026" data-mp="i1jo4rbvpu17" />
                <label htmlFor={`mediaConsent-${option}`} className="text-gray-700" data-id="element-1027" data-mp="89x4c6lh6mmu">
                  {option}
                </label>
              </div>)}
          </div>
        </div>
        <div data-id="element-1028" data-mp="10tvppbupkraa">
          <label htmlFor="comments" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1029" data-mp="10uf78rgg5dns">
            Additional Comments or Suggestions (You can ask your questions
            here): <span className="text-gray-500" data-id="element-1030" data-mp="2gjdb50j5k99e">(optional)</span>
          </label>
          <textarea id="comments" name="comments" value={formData.comments} onChange={handleChange} rows={3} className="w-full p-2 border border-gray-300 rounded-md" placeholder="Enter any additional comments or questions" data-id="element-1031" data-mp="2v7rerdoe81r0" />
        </div>
      </div>
      {isFormComplete ? <PaystackPayment amount={20000} email={formData.email} name={formData.fullName} phone={formData.phone} onSuccess={onSuccess} metadata={{
      ...formData
    }} data-id="element-1032" data-mp="1xlak6g71o28y" /> : <button disabled className="w-full py-2 px-4 bg-gray-300 text-gray-500 rounded-md cursor-not-allowed" data-id="element-1033" data-mp="2bipbxrkrsm43">
          Complete all required fields to proceed
        </button>}
    </div>;
};